



































import { biHT } from '@/business/bi';
import Vue from 'vue';
import { getStampList } from '../api';
import homeStore from '../views/stores/home.js';
import { windowHelper } from '@tencent/ppd-base-libs';
/**
 * 获取正在进行中的活动
 * 动列表只展示进行中的活动（即活动开始时间 > 当前时间 > 活动结束时间）【未到活动开始时间的活动】和【已过活动结束时间的活动】不在【优惠专区首页的活动列表】中展示
 * @param  {[type]} actList [description]
 * @return {[type]}         [description]
 */

export default Vue.extend({
  name: 'stamplist',
  data() {
    return {
      homeStore,
      stamp: '',
      showList: false,
      page_num: 1,
      working: 1,
      test2: 'https://st.moneydata.hk/res/weixin/hkwallet/wallet/img/bank_cards/bank_icons/4504.png',
    };
  },
  components: {

  },
  created() {
    document.title = homeStore.GO_UNUSABLE;
    this.getStamp();
    biHT('promozone.previousstamplist_brow');
  },
  methods: {
    async getStamp() {
      const stamp = await getStampList({
        page_size: '10',
        page_num: '0',
        is_working: '2',
      });
      this.stamp = stamp;
      this.showList = stamp.length > 0;
    },
    goDetail(list) {
      biHT('promozone.previousstamplist.stamp_click');
      windowHelper.redirect(list, 300);
    },
    getTips() {
      return homeStore.EXPIRE_STAMP;
    },
  },
});
